import { AxDatePicker, Cell } from "./AxDatepicker";
import { InteractionHelper } from "./InteractionHelper";

export class AxPEventHelper {
    private Parent: AxDatePicker;

    constructor(private ActionHelper: InteractionHelper = new InteractionHelper()) { }

    public AnimationDuration = 250;
    public InAnimation: boolean = false;

    public Init(parent: AxDatePicker) {
        this.Parent = parent;
    }

    public AddDayActivation(cell: Cell) {
        cell.Element.addEventListener("click", ev => {
            this.ActionHelper.ActivateDay(cell, this.Parent, true);
        });
    }

    public setDate(date: moment.Moment) {
        this.InAnimation = true;
        this.ActionHelper.setDate(date, this.Parent, (a, b) => { this.AsyncNavigate(a, b) });
    }

    public AddNavigatorEvents(elem: HTMLElement, direction: Direction) {
        elem.addEventListener("click", ev => {
            if (this.InAnimation == false) {
                this.InAnimation = true;

                if (direction == Direction.Forward) {
                    this.ActionHelper.Next(this.Parent, (a, b) => { this.AsyncNavigate(a, b) });
                } else {
                    this.ActionHelper.Previous(this.Parent, (a, b) => { this.AsyncNavigate(a, b) });
                }
            }
        });
    }

    public AsyncNavigate(newEntries: HTMLElement[], direction: Direction) {
        if (newEntries.length == 0) {
            this.InAnimation = false;
            return;
        }

        //I hate JS Size calculations
        let currentHeight = this.Parent.RootElement.offsetHeight;
        let currentWidth = this.Parent.RootElement.parentElement.offsetWidth;

        if (currentHeight !== 0) {
            this.Parent.RootElement.style.height = `${currentHeight}px`;
        }
        if (currentWidth !== 0) {
            this.Parent.RootElement.parentElement.style.width = `${currentWidth}px`;
            this.Parent.RootElement.parentElement.style.minWidth = `${currentWidth}px`;
            this.Parent.RootElement.parentElement.style.maxWidth = `${currentWidth}px`;
        }

        let newWeekRows = 0;
        let orgWeekRows = 0;
        let rowHeight = (this.Parent.RootElement.querySelector('.axp__week-Wrapper') as HTMLElement).offsetHeight;

        let currentMonths = this.Parent.RootElement.querySelectorAll('.axp__month');
        for (let i = 0; i < currentMonths.length; ++i) {
            let weekRows = currentMonths[i].querySelectorAll('.axp__week-Wrapper').length;
            if (weekRows > orgWeekRows) {
                orgWeekRows = weekRows;
            }
        }

        for (let entry of newEntries) {
            let weekRows = entry.querySelectorAll('.axp__week-Wrapper').length;
            if (weekRows > newWeekRows) {
                newWeekRows = weekRows;
            }
        }

        let newHeight = (currentHeight + ((newWeekRows - orgWeekRows) * rowHeight));
        // Puh, I'm glad it's done

        let count = 0;

        if (direction === Direction.Jump) {
            this.Parent.RootElement.innerHTML = '';
        }

        for (const elem of $(this.Parent.RootElement).find('.axp__month')) {
            $(elem).css('min-width', `${elem.getBoundingClientRect().width}px`);
        }

        for (let entry of newEntries) {
            switch (direction) {
                case Direction.Forward:
                case Direction.Jump:
                    this.Parent.RootElement.appendChild(entry);
                    break;
                case Direction.Backward:
                    this.Parent.RootElement.style.marginLeft = "-100%";
                    this.Parent.RootElement.insertBefore(entry, this.Parent.RootElement.children[count]);
                    break;
                default:
                    console.log(`Unsupported direction.`);
            }
            count++;
        }

        this.SwitchMonth(direction, newHeight);
    }

    public SwitchMonth(direction: Direction, height: number) {

        let margin = 0;

        switch (direction) {
            case Direction.Forward:
                margin = 100 * -1;
                break;
            case Direction.Backward:
            case Direction.Jump:
                margin = 100 * 0;
                break;
        }

        let animateProperties: JQuery.PlainObject = {
            'marginLeft': `${margin}%`,
        };

        if (height !== 0) {
            animateProperties.height = `${height}px`;
        }
        
        $(this.Parent.RootElement).animate(animateProperties, this.AnimationDuration, 'linear', () => {
            if (direction == Direction.Forward) {
                for (let i = 0; i < this.Parent.monthsShown; i++) {
                    this.Parent.RootElement.removeChild(this.Parent.RootElement.firstChild);
                }
            } else if (direction == Direction.Backward) {
                for (let i = 0; i < this.Parent.monthsShown; i++) {
                    this.Parent.RootElement.removeChild(this.Parent.RootElement.lastChild);
                }
            }


            this.Parent.CleanUpCells();
            this.Parent.RootElement.parentElement.style.width = "";
            this.Parent.RootElement.parentElement.style.maxWidth = "";
            this.Parent.RootElement.parentElement.style.minWidth = "";
            this.Parent.RootElement.style.marginLeft = "0";
            this.InAnimation = false;

            for (const elem of $(this.Parent.RootElement).find('.axp__month')) {
                $(elem).css('min-width', null);
            }

            if (this.Parent.Options.AfterChange != null) {
                this.Parent.Options.AfterChange(this.Parent.CurrentStartDate, this.Parent.CurrentEndDate);
            }
        });
    }
}

export enum Direction {
    Forward,
    Backward,
    Jump
}